export function SwitcherOnIcon() {
  return (
    <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.3" width="20" height="12" rx="6" transform="matrix(-1 0 0 1 20 0)" fill="#00BCD4" />
      <circle cx="14" cy="6" r="5" fill="#14B8A6" />
    </svg>
  );
}
